import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ModernNavbar from './components/ModernNavbar';
import ModernFooter from './components/ModernFooter';
import ModernHomePage from './pages/ModernHomePage';
import FixedUnitPage from './pages/FixedUnitPage';
import NotesPage from './pages/NotesPage';
import PastPapersPage from './pages/PastPapersPage';
import AboutPage from './pages/AboutPage';
import InfoPage from './pages/InfoPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <ModernNavbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<ModernHomePage />} />
            <Route path="/semester/:semesterId" element={<ModernHomePage />} />
            <Route path="/unit/:unitName" element={<FixedUnitPage />} />
            <Route path="/unit/:unitName/notes" element={<NotesPage />} />
            <Route path="/unit/:unitName/past-papers" element={<PastPapersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/info" element={<InfoPage />} />
          </Routes>
        </main>
        <ModernFooter />
      </div>
    </Router>
  );
}

export default App;
